module.exports = __webpack_public_path__ + "7eba9677.svg";